import styled, { css } from 'styled-components';
import { CardMainBody } from '../../../../shared/components/Card/Card.styles';

export const SupportCardWrapper = styled.div<{
  $height?: string;
  $width?: string;
}>`
  ${({ $height = '100%', $width = '100%' }) => css`
    display: flex;
    flex-direction: row;
    height: ${$height};
    width: ${$width};
  `}
`;

export const SupportCardBody = styled(CardMainBody)`
  display: flex;
  flex-direction: row;
`;

export const SupportCardIcon = styled.div`
  max-height: 78px;
`;

export const SupportCardContent = styled.div`
  display: flex;
  flex-direction: column;
`;
